module.exports = __webpack_public_path__ + "img/device5.f35dc1a3.png";